const moment = require("moment");

moment.locale("de");

function isKAOpen() {
  const currentTime = moment();
  const currentDay = currentTime.isoWeekday();
  let isOpen = false;

  if (currentDay >= 1 && currentDay <= 5) {
    const startTime = moment("09:00", "HH:mm");
    const endTime = moment("20:00", "HH:mm");
    if (currentTime.isBetween(startTime, endTime, null, "[]")) {
      isOpen = true;
    }
  } else if (currentDay === 6) {
    const startTime = moment("09:00", "HH:mm");
    const endTime = moment("16:00", "HH:mm");
    if (currentTime.isBetween(startTime, endTime, null, "[]")) {
      isOpen = true;
    }
  }
  return isOpen;
}

export default isKAOpen;
